/** Profiles SoT breadcrumb for Feedback subpages (Work / …). */
export function FeedbackPageBreadcrumb({
  domainLabel,
  pageLabel,
}: {
  domainLabel: string;
  pageLabel: string;
}) {
  return (
    <>
      {domainLabel}
      <span className="mx-1.5 text-muted-foreground/70">/</span>
      {pageLabel}
    </>
  );
}
